import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';


import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';

import { OfferletterviewComponent } from '../elcm/offerletterview/offerletterview.component';

import { MatCheckboxChange } from '@angular/material/checkbox';
import { SharedService } from 'src/app/service/shared/shared.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { first } from 'rxjs';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';

@Component({
  selector: 'app-offer-letter-preview',
  templateUrl: './offer-letter-preview.component.html',
  styleUrls: ['./offer-letter-preview.component.scss'],
})
export class OfferLetterPreviewComponent implements OnInit {
  yearList: any[] = [];
  selectedYear: any;
  buttonColorName: any;
  loggedInUserCompanyID: any;
  incrementId: any;
  loggedInUserRole: any;
  getIncrementFyYearList: any[] = [];
  fromYear: any;
  toYear: any;
  dropdownSettings: IDropdownSettings = {};
  selectedDepartment: any;
  selectedBand: any;
  selectedManager: any;
  selectedEmployee: any;
  selectedRating: any;
  managerId: any;
  employeeId: any;
  searchOfferTableData: any;
  loggedInCompanyFiscalyear: any;
  getIncrementInputYear: any[] = [];
  companyYears: any[] = [];
  getDepartmentsList: any[] = [];
  getBandList: any[] = [];
  getManagerList: any[] = [];
  getEmployeeList: any[] = [];
  getSelectedRating: any[] = [];
  getRatingData: any[] = [];
  isShowDownloadBtn: boolean = false;
  selectAllChecked: boolean = false;

  incrementLetterData: any[] = [];
  candidateId: any;
  candidateData: any;
  constructor(private route: Router, private httpService: HttpService, private config: Config,
    private encryptionService: EncryptionService, public dialog: MatDialog, public sharedService: SharedService,
    private http: HttpClient, @Inject(MAT_DIALOG_DATA) public candidatedata: any, public mobileResponsiveService: MobileResponsiveService) {
    console.log(candidatedata.candidateID);
    this.candidateId = candidatedata?.candidateID?.candidateId
    this.candidateData = candidatedata?.candidateID;
  }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserRole = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }


    this.getpmsyearlist();

  }
  pmsYears: any = []
formatDate(dateString: string): string {
  if (!dateString) return '';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();

  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  };

  const formattedDate = `${day}/${month}/${year}`;
  const formattedTime = new Intl.DateTimeFormat('en-US', timeOptions).format(date);

  return `Date: ${formattedDate}\nTime: ${formattedTime}`;
}




  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      // Additional function calls
      this.getEmployeeListForOfferleter();
    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');

    }
  }
  allSelectedData: any = []
  toggleSelectAll() {
    this.offerLetterData.forEach((item: any) => item.isChecked = this.selectAllChecked);

    this.allSelectedData = this.offerLetterData
    this.isShowDownloadBtn = this.selectAllChecked; // Show download if all are selected

  }
  offerlettterDataForSingleSelection: any = []
  checkedEmployees: any = []
  onCheckboxChange(event: MatCheckboxChange, employee: any) {
    if (event.checked) {
      // Add employee to the checked list if checked
      this.checkedEmployees.push(employee);
    } else {
      // Remove employee from checked list if unchecked
      this.checkedEmployees = this.checkedEmployees.filter((elm: any) => elm.candidateId !== employee.candidateId);
    }

    // Update appointment letter data to show only checked employees
    this.offerlettterDataForSingleSelection = [...this.checkedEmployees];
    const allChecked = this.offerLetterData.every((item: any) => item.isChecked);
    const anyChecked = this.offerLetterData.some((item: any) => item.isChecked);


    this.selectAllChecked = allChecked; // Update 'Select All' state
    this.isShowDownloadBtn = anyChecked; // Show download button if at least one is checked
  }
  downloadSelected() {
    const selectedIds = this?.offerLetterData
      ?.filter((data: any) => data.isChecked)
      .map((data: any) => data.candidateId);

    if (!selectedIds || selectedIds.length === 0) {
      console.warn("No items selected for download.");
      return;
    }

    if (this.selectAllChecked) {

      this.allSelectedData = this.offerlettterDataForSingleSelection.length > 0 ? this.offerlettterDataForSingleSelection : this.allSelectedData;
      this.allSelectedData.forEach((elm: any) => {
        this.viewDocument(elm.fileName);
      })
    } else {
      if (!this.offerlettterDataForSingleSelection) {
        console.error("Download URL is not defined.");
        return;
      }
      // const fileName = this.appoinmentlettterData.split('/').pop() || "downloaded-file";
      this.offerlettterDataForSingleSelection.forEach((elm: any) => {
        this.viewDocument(elm.fileName);
      })
    }

  }


  viewDocument(fileUrl: string): void {

    if (fileUrl) {
      // Open the document in a new tab
      fileUrl = `${this.config.downloadFile}${this.loggedInUserCompanyID}/${fileUrl}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }

  onClickPreviewLetter(userName: any, userId: any, fileName: any) {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.height = '70%';
    // dialogConfig.width = '100%';
    dialogConfig.maxWidth= this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.data = {
      userName: userName,
      userId: userId,
      fileName: fileName,
      incrementLetterData: this.incrementLetterData // Pass the full data here
    };
    dialogConfig.panelClass = 'phi_mdc_dialog__container_100';
    const dialogRef = this.dialog.open(OfferletterviewComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => { });
  }



  filteredEmployees: any = [];
  employees: any = [];
  offerLetterData: any = [];
  curretofferLetterData: any = [];
  getEmployeeListForOfferleter() {

    this.httpService.callGetService(`${this.config.getListPriviewOfferLetter}?companyId=${this.loggedInUserCompanyID}&fileType=Offer Letter&candidateId=${this.candidateId}`).subscribe((record: any) => {
      this.filteredEmployees = record.pdfRecords;


      this.offerLetterData = this.filteredEmployees.map((elm: any) => {
        // Find all records that match by candidateId


        return {
          ...elm,
           firstName: this.candidateData?.firstName,
           lastName: this.candidateData?.lastName,
          // If there are multiple matches, join departments into a string or store as an array

          isChecked: false
        };
      });
     
      

    })


  }







}
